module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_sp_002-278cd3153fe8cf01cda54c040ffd0588.png";